module.exports = __webpack_public_path__ + "img/eye.2e1955f2.svg";